<template>
  <section>
    <va-modal
      ref="showHearingLossRule"
      :value="isOpen"
      :showOkay="false"
      :cancelText="$t('modals.buttons.back')"
      @cancel="onCancel"
    >
      <div slot="header" class="d-flex flex-column align-items-start">
        <span class="modal-title">{{ $t('hearinglossrules.details') }}</span>
      </div>

      <div class="modal-header-actions d-flex justify-content-end" v-if="hasWriteRulesPermissions">
        <va-popover
          placement="left"
          :message="$t('hearinglossrules.update_rule')">
          <va-button
            large
            class="va-button-rounded"
            icon="fa fa-pencil"
            color="gray"
            @click="updateRule">
          </va-button>
        </va-popover>
      </div>

      <div><span class="is-bold">{{ $t('hearinglossrules.labels.questionaire') }}:</span> {{ $t('hearinglossrules.labels.>=') }} {{hearingLossRule.min_quest_value}}</div>
      <div><span class="is-bold">{{ $t('hearinglossrules.labels.hearing_test') }}:</span> {{ $t('hearinglossrules.labels.threshold_type.' + hearingLossRule.threshold_type) }} {{hearingLossRule.threshold}} dB HL</div>
      <div><span class="is-bold">{{ $t('hearinglossrules.labels.diagnosed_hl_full') }}:</span> {{ $t('hearinglossrules.labels.' + hearingLossRule.diagnosed_hl) }}</div>
      <div><span class="is-bold">{{ $t('hearinglossrules.labels.hearing_aid_full') }}:</span> {{ $t('hearinglossrules.labels.' + hearingLossRule.hearing_aid) }}</div>

    </va-modal>

    <CreateOrUpdateHearingLossRule
      v-if="isUpdatingRule"
      :entity="entity"
      :hearingLossRule="hearingLossRule"
      @rule-updated="onRuleUpdated"
      @rule-deleted="onRuleDeleted"
      @cancel="onCancelUpdateRule"
    />
  </section>
</template>
<script>
import CreateOrUpdateHearingLossRule from '@/components/entities/hearinglossrules/CreateOrUpdateHearingLossRule'

export default {
  props: {
    hearingLossRule: {
      type: Object,
      required: true
    },
    entity: {
      type: Object,
      required: true
    }
  },
  components: {
    CreateOrUpdateHearingLossRule
  },
  computed: {
    hasWriteRulesPermissions: function () {
      return this.$auth.user().entity.id === 1
    }
  },
  data: function () {
    return {
      isOpen: false,
      isUpdatingRule: false
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    updateRule: function () {
      this.isOpen = false
      this.isUpdatingRule = true
    },
    onRuleUpdated: function (event) {
      this.$emit('rule-updated', event)
    },
    onRuleDeleted: function (event) {
      this.$emit('rule-deleted', event)
      this.onCancel()
    },
    onCancelUpdateRule: function () {
      this.isUpdatingRule = false
      this.isOpen = true
    },
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('cancel')
      }, 500)
    }
  }
}
</script>
